/**
 * Hyperlink text for opening the original-item experience (modal / transcript / etc.).
 * Driven by cxItem.businessCategory only (see product spec).
 */
export function getOriginalItemViewLabel(
  businessCategory: string | null | undefined
): string {
  switch (businessCategory) {
  case 'call':
    return 'View Call Transcript';
  case 'ticket':
    return 'View Full Ticket/Case';
  case 'survey':
    return 'View Survey';
  case 'chat':
    return 'View Chats';
  case 'request':
    return 'View Request';
  case 'customerInterview':
    return 'View Original Notes';
  case 'generalFeedback':
    return 'View Original Text';
  case 'other':
    return 'View Original Text';
  default:
    return '';
  }
}
